import create from 'zustand';

type LineIndexStore = {
    count: number;
    lineIndex: Record<string, number>;
    register: (moduleId: string) => void;
};

export const useLineIndex = create<LineIndexStore>((set, get) => ({
    count: 0,
    lineIndex: {},
    register: (moduleId) => {
        const { lineIndex, count } = get();
        if (lineIndex[moduleId] !== undefined) {
            return;
        }
        set(() => ({
            lineIndex: {
                ...lineIndex,
                [moduleId]: count,
            },
            count: count + 1,
        }));
    },
}));
